import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import { Heading, Paragraph } from '@nrk/dh-feature-components'
import PureComponent from '../../../lib/preact-pure-component'
import { Lottie } from '../../lottie'
import classNames from 'classnames'
import { Svg } from './intro_text'

interface Props {
  title: string
  lead: string
  byline: string
  id: string
  active: boolean
  preload: boolean
}

interface State {
  loaded: boolean
}

export class Intro extends PureComponent<Props, State> {
  constructor() {
    super()
    this.state = {
      loaded: false
    }
  }

  onDomLoaded = () => {
    this.setState({ loaded: true })
  }

  render() {
    const data = require('./Intro_text.json')
    const active = typeof window !== 'undefined' && this.props.active
    const wrapperClasses = classNames(style.textwrapperIntro, { [style.active]: this.state.loaded })
    const renderAnimation = typeof window !== 'undefined' && (this.props.active || this.props.preload)
    const renderSvg = !renderAnimation
    return (
      <div className={wrapperClasses}>
        <h1 className="nrk-sr">{this.props.title}</h1>
        {renderSvg && <Svg />}
        {renderAnimation && <Lottie loaded={this.onDomLoaded} play={this.props.active} animationData={data} />}
        <Paragraph className={style.lead} html={this.props.lead} />
      </div>
    )
  }
}
